import * as React from "react";
import { createContext, useContext } from "react";
import { KahunaWidgetConfiguration } from "../d";

const PartnerContext = createContext<KahunaWidgetConfiguration>(null);

export interface WidgetSettingsContextProps {
  widgetSettings?: KahunaWidgetConfiguration;
  children?: React.ReactNode;
}

export const WidgetSettingsContext = React.memo(
  ({ widgetSettings = null, children = null }: WidgetSettingsContextProps) => {
    const ContextProvider = PartnerContext.Provider;
    return <ContextProvider value={widgetSettings}>{children}</ContextProvider>;
  },
);

export const useWidgetSettings = () => useContext(PartnerContext) || {};
